<template>
  <div class="container">
    <div class="headTxt">
      <spot :title="'加时卡记录'"></spot>
    </div>

      <div class="tabSty">
        <div class="wd">日期</div>
        <div class="wd">类型</div>
        <div class="wd">数量</div>
        <div class="lastWd">
          <van-dropdown-menu>
            <van-dropdown-item
              v-model="useValue"
              :options="useOption"
              @change="onOptionClick"
            >
              <template slot="title">
                <span>{{ customizeTitle || "用途" }}</span>
              </template>
            </van-dropdown-item>
          </van-dropdown-menu>
        </div>
      </div>
    <template v-if="tabList.length">
      <div class="listSty">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          :offset="2"
          @load="onLoad"
        >
          <div class="cellSty" v-for="(item, index) in tabList" :key="index">
            <div class="wd">{{ item.day }}</div>
            <div class="wd">{{ item.category }}</div>
            <div class="wd">{{ item.number }}张</div>
            <div class="lastWd">
              <div></div>
              <div>{{ item.purpose_val }}</div>
            </div>
          </div>
        </van-list>
      </div>
    </template>
    <Empty :word="'暂无记录'" v-else></Empty>
  </div>
</template>

<script>
import { DropdownMenu, DropdownItem, List, Cell } from "vant";
import Empty from "./components/Empty.vue";
import spot from "./components/spot.vue";
import { entertainmenttimecardlog } from "@/api/squirrelCup";

export default {
  data() {
    return {
      useValue: "",
      customizeTitle: "",
      loading: false,
      finished: false,
      page: {
        pageIndex: 0,
        pageSize: 15,
      },
      total: null,
      useOption: [
        { text: "奖励", value: 1 },
        { text: "使用", value: 2 },
        { text: "过期", value: 3 },
      ],
      tabList: [],
    };
  },
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [List.name]: List,
    [Cell.name]: Cell,
    Empty,
    spot,
  },
  mounted() {
    this.onLoad();
    document.title ="加时卡记录"
  },
  methods: {
    getLoadLIst(val) {
      this.loading = true;
      let acountId = JSON.parse(localStorage.getItem("headInfo")).accountId;
      const postData = {
        ...this.page,

        param: {
          account_id: acountId, // 账号ID
          purpose: val || 1, // 用途：1，奖励；2，使用；3，过期
        },
      };
      entertainmenttimecardlog(postData).then((res) => {
        this.total = res.data.count;
        this.tabList = this.tabList.concat(res.data.log);
        this.loading = false;
        if (this.tabList.length  >= this.total)
          return (this.finished = true);
      });
      //
    },
    onLoad() {
      this.page.pageIndex++;
      this.getLoadLIst();
    },
    onOptionClick(value) {
      this.tabList = [];
      this.getLoadLIst(value);
      console.log(value, this.useValue, "useValue");
      this.customizeTitle = this.useOption[value - 1].text;
    },
  },
};
</script>
<style scoped lang="less">
.container {
  width: 100%;
  overflow: hidden;
  .headTxt {
    margin: 48px;
  }
  .listSty {
    height: calc(100vh - 300px);
    overflow: auto;
    width: 100%;
  }
  .tabSty,
  .cellSty {
    display: flex;
    justify-content: space-between;
    font-size: 32px;
    align-items: center;
    font-size: 28px;
    color: #323232;
    margin: 0 16px;
    margin-bottom: 20px;
  }
  .tabSty {
    background: rgba(88, 171, 246, 0.12);
  }
  .wd {
    width: 20%;
    text-align: center;
  }
  .lastWd {
    margin: 0 auto;
    text-align: center;
    flex: 1;
  }
  .cellSty {
    font-size: 26px;
    padding: 10px 0;
    padding-bottom: 40px;
    border-bottom: 2px solid rgba(88, 171, 246, 0.2);
  }
  /deep/ .van-dropdown-menu__bar {
    background-color: transparent;
    box-shadow: none;
  }
}
</style>
